import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { CookiesProvider, useCookies } from 'react-cookie'
import { AssessmentDashboard } from "./screens/Assessment/Assessment-dashboard/Assessment-dashboard";
import { PEARLIReports } from "./screens/Assessment/Reports/PEARLIReports";
import { TakeDeepBreath } from "./screens/TakeDeepBreath/TakeDeepBreath";
import { StartScreen } from "./screens/Assessment/StartScreen/StartScreen";
import { PhysicalDashboard } from "./screens/Assessment/Physical-Assessment/Physical-Assessment";
import { PhysicalDomain } from "./screens/Assessment/Components/PhysicalDomain";
import { MainContentDisclaimer } from "./screens/Assessment/Disclaimer/MainContentDisclaimer";
import { UserData } from "./screens/Assessment/UserData/UserData";
import PrivacyPolicyPage from './screens/privacy-policy-page/PrivacyPolicy';
import TermsOfUsePage from './screens/terms-condition-page/TermsOfUsage';
// import { Copyrights } from './screens/CopyRights/Copyrights';

export default function App() {
  const [isLoading, setIsLoading] = useState(() => {
    return !sessionStorage.getItem("hasShownLoading");
  });

  useEffect(() => {
    if (isLoading) {
      const timeout = setTimeout(() => {
        sessionStorage.setItem("hasShownLoading", "true");
        setIsLoading(false);
      }, 6000);
      return () => clearTimeout(timeout);
    }
  }, [isLoading]);

  return (
    <CookiesProvider>
      {isLoading ? (
        <TakeDeepBreath />
      ) : (
        <Router>
          <Routes>
            <Route path="/" element={<StartScreen />} />
            <Route path="/Disclaimer" element={<MainContentDisclaimer />} />
            <Route path="/assesments" element={<AssessmentDashboard />} />
            <Route path="/PEARLIReports" element={<PEARLIReports />} />
            <Route path="/Assessment/maincontent/:domain" element={<PhysicalDashboard />} />
            <Route path="/Question-card/:domain" element={<PhysicalDomain />} />
            <Route path="/UserData" element={<UserData />} />
            {/* <Route path="/copyrights" element={<Copyrights />} /> */}
            <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
            <Route path="/terms-of-usage" element={<TermsOfUsePage />} />


          </Routes>
        </Router>
      )}
      <ToastContainer />
    </CookiesProvider>
  );
}